/**
 * Contains utility functions to create entity names and pretty print entity's
 *
 * @module
 */
import { type Doc } from "building-types/doc";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import { docGetEntityName } from "doc/docGetEntityName";
import docEntityGetParent from "doc/entity/docEntityGetParent";

export function docGetEntityBreadcrumbString(doc: Doc, handle: DocEntityHandle): string {
  return docGetEntityBreadcrumbNameArray(doc, handle).join(" > ");
}

function docGetEntityBreadcrumb(doc: Doc, handle: DocEntityHandle): DocEntityHandle[] {
  let internalHandle: DocEntityHandle | undefined = handle;

  const e: DocEntityHandle[] = [];

  while (internalHandle) {
    e.push(internalHandle);
    internalHandle = docEntityGetParent(doc, internalHandle);
  }

  return e;
}

function docGetEntityBreadcrumbNameArray(doc: Doc, handle: DocEntityHandle): string[] {
  return docGetEntityBreadcrumb(doc, handle)
    .reverse()
    .map((x) => docGetEntityName(doc, x));
}

export function docGetEntityBreadcrumbNameArrayWithHandles(
  doc: Doc,
  handle: DocEntityHandle,
): { name: string; handle: DocEntityHandle }[] {
  return docGetEntityBreadcrumb(doc, handle)
    .reverse()
    .map((x) => ({ name: `${docGetEntityName(doc, x)}`, handle: x }));
}
